document.addEventListener('DOMContentLoaded', function(){
    let productForm = document.querySelector('form.cart');
    if (productForm) {
        let isNewProductPage = document.body.classList.contains('product-template-new-product-page');
        let isFirstChangeVariation = true;
        let isFirstChangeFabrics = true;
        let isFirstChangeOptions = true;
        let configOpened = false;
        let isConfigurationChanged = false;

        let uuid = lav.uid() || getCookie('_dat_uid');
        let optionObject = JSON.parse(productForm.dataset.option_object || '{}');
        let fabricObject = JSON.parse(productForm.dataset.fabric_object || '{}');
        let defaultFabricId = parseInt(productForm.dataset.default_fabric_id);
        let productCategory = productForm.dataset.product_category;
        let productCollection = productForm.dataset.product_collection;
        let productFeature = productForm.dataset.product_feature;

        let fabrics = new Map();
        let fabricCategories = new Map();
        if (fabricObject['fabrics']) fabricObject['fabrics'].forEach(fabric => fabrics.set(fabric['id'], fabric));
        if (fabricObject['categories']) fabricObject['categories'].forEach(category => fabricCategories.set(category['id'], category));
        let fabric = defaultFabricId ? fabrics.get(defaultFabricId) : null;
        let fabricCategory = fabric ? fabricCategories.get(fabric['category_id']) : null;

        function newConfigId() {
            if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                const r = Math.random() * 16 | 0;
                return (c === "x" ? r : (r & 3) | 8).toString(16);
            });
        }

        let materials = defaultFabricId ? {
            slot: "upholstery",
            label: "Обивка",
            value: fabric['title'],
            category: fabricCategory ? fabricCategory['name'] : null
        } : null;
        let options = [];
        let lavData = {
            config_id: uuid,
            category: productCategory,
            collection: productCollection,
            feature: productFeature,
            materials: materials ? [materials] : [],
            options: options,
        };

        function openConfigurator(entryPoint) {
            if (configOpened) return;
            configOpened = true;
            uuid = newConfigId();
            lavData.config_id = uuid;
            lav.setConfig(uuid);
            lav.track("configurator_open", { configurator_type: "variant_panel", entry_point: entryPoint });
        }

        if (productForm.classList.contains('simple_form')) {
            jQuery(document.body).on('show_product', (evt, product) => {
                lavData.price = product['price'];
                lavData.product_id = product['id'];
                lavData.title = product['name'];

                lav.setProduct(lavData);
                lav.track("product_view", {
                    product_name: product['name'],
                    price: product['price']
                });
            })
        }

        if (productForm.classList.contains('variations_form')) {
            lavData.variation_id = null;
            jQuery(productForm).on('show_variation', (evt, variation) => {
                if (lavData.variation_id === variation['variation_id']) {
                    return;
                }

                lavData.title = variation['title'];
                lavData.product_id = variation['product_id'];
                lavData.price = variation['display_price'];
                lavData.variation_id = variation['variation_id'];
                lavData.variation = variation['attribute_labels'][Object.values(variation['attributes'])[0]];

                lav.setProduct(lavData);

                if (isFirstChangeVariation) {
                    isFirstChangeVariation = false;

                    lav.track("product_view", {
                        product_name: variation['title'],
                        price: variation['display_price']
                    });
                } else {
                    isConfigurationChanged = true;
                    lav.track("product_variant_select", {
                        option_group: "size",
                        option_value: variation['attribute_labels'][Object.values(variation['attributes'])[0]],
                        price: variation['display_price']
                    });
                }
            });
        }

        jQuery(productForm).on('fabric_changed', (evt, fabric) => {
            if (isNewProductPage && isFirstChangeFabrics) {
                isFirstChangeFabrics = false;
                return;
            }

            if (materials && materials.value === fabric['title']) {
                return;
            }

            isConfigurationChanged = true;
            fabricCategory = fabricCategories.get(fabric['category_id']);
            materials = materials || { slot: "upholstery", label: "Обивка" };
            materials.category = fabricCategory ? fabricCategory['name'] : null;
            materials.value = fabric['title'];
            lavData['materials'] = [materials];

            lav.setProduct(lavData);
            lav.track("configurator_option_select", {
                option_group: "upholstery",
                option_value: fabric['title'],
            });
        });

        jQuery(productForm).on('options_changed', (evt, changesOptions) => {
            options = [];
            changesOptions.forEach(option => {
                let optionGroupId = option['group_id'];
                options.push({
                    label: optionObject['groups'][optionGroupId]['title'],
                    value: option['title']
                })
            })

            if (JSON.stringify(lavData['options']) === JSON.stringify(options)) {
                return;
            }

            lavData['options'] = options;

            if (isFirstChangeOptions) {
                isFirstChangeOptions = false;
                return;
            }

            isConfigurationChanged = true;
            lav.setProduct(lavData);
            lav.track("configurator_option_select", {
                option_group: "options",
                option_value: options,
            });
        });

        let addToCartButtons = document.querySelectorAll('.add_to_cart_button, .single_add_to_cart_button, .checkout');
        if (addToCartButtons.length) {
            addToCartButtons.forEach(button => {
                button.addEventListener('click', () => {
                    if (isConfigurationChanged) {
                        lav.track("configurator_complete", {
                            "configurator_type": "variant_panel",
                            "outcome": "cart",
                            "price": lavData.price
                        });
                    }
                })
            });
        }

        let productSidebarsButtons = document.querySelectorAll('.product-constructor-sidebar-trigger');
        if (productSidebarsButtons.length) {
            productSidebarsButtons.forEach(button => {
                button.addEventListener('click', () => {
                    openConfigurator("");
                })
            });
        }

        let productVariationsSidebarsButtons = document.querySelectorAll('.variations-sidebar-trigger');
        if (productVariationsSidebarsButtons.length) {
            productVariationsSidebarsButtons.forEach(button => {
                button.addEventListener('click', () => {
                    openConfigurator("size_select");
                })
            });
        }

        let productFabricSidebarsButtons = document.querySelectorAll('.fabric-main-trigger');
        if (productFabricSidebarsButtons.length) {
            productFabricSidebarsButtons.forEach(button => {
                button.addEventListener('click', () => {
                    openConfigurator("change_fabric_btn");
                })
            });
        }

        let productOptionsSidebarsButtons = document.querySelectorAll('.options-trigger');
        if (productOptionsSidebarsButtons.length) {
            productOptionsSidebarsButtons.forEach(button => {
                button.addEventListener('click', () => {
                    openConfigurator("option_select");
                })
            });
        }
    }

    let isProductCatPage = document.body.classList.contains('tax-product_cat');
    if (isProductCatPage) {
        let productPage = document.querySelector('.products.is-shop-catalog');
        let productItemsCount = productPage.dataset.productCount;
        let productCategory = productPage.dataset.productCategory;
        lav.track("product_list_view", {
            "list_id": productCategory,
            "items_count": productItemsCount
        });

        let productItems = document.querySelectorAll('.products.is-shop-catalog .product__inner, .products.is-shop-catalog .horizontal-variation__thumbnail-wrapper');
        productItems.forEach(item => {
            item.addEventListener('click', (evt) => {
                let elem = evt.currentTarget.closest('.product') || evt.currentTarget.closest('.horizontal-product');
                let productData = JSON.parse(elem.dataset.ecommerceProduct);
                let productId = productData.id;
                let positionNum = Number(elem.dataset.catalogNum);
                lav.track("product_click", {
                    "product_id": productId,
                    "list_id": productCategory,
                    "position": positionNum
                });
            })
        })
    }

    let quizSteps = document.querySelectorAll('.quiz-section form .step');
    if (quizSteps.length) {
        const quizStepsCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    lav.track("configurator_step_view", {
                        "configurator_type": "quiz_custom",
                        "step_index": entry.target.dataset.step
                    });
                }
            });
        };

        quizSteps.forEach(step => {
            const quizStepsObserver = new IntersectionObserver(quizStepsCallback);
            quizStepsObserver.observe(step);
        });
    }

    let quizForms = document.querySelector('.quiz-section form');
    if (quizForms) {
        quizForms.addEventListener('submit', (evt) => {
            lav.track("configurator_complete", {
                "configurator_type": "quiz_custom",
                "outcome": "form"
            });
        });
    }

    document.addEventListener('wpcf7mailsent', function (evt) {
        lav.track("captcha_result", {
            "form_id": evt.detail.contactFormId,
            "provider": "smartcaptcha"
        });
    });

    document.addEventListener('wpcf7invalid', function (evt) {
        lav.track("captcha_result", {
            "form_id": evt.detail.contactFormId,
            "provider": "smartcaptcha",
            "error_type": "captcha_failed"
        });
    });
});
